import { PropsWithChildren, forwardRef } from "react";
import { Badge, Flex, Text } from "@radix-ui/themes";
import { useElementSize } from "@/v2/shared/hooks/useElementSize";

interface TableScrollAreaProps {
  handleScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  isLoadingMore?: boolean;
  isEmpty?: boolean;
}

const TableScrollArea = forwardRef<
  HTMLDivElement,
  PropsWithChildren<TableScrollAreaProps>
>(({ handleScroll, isLoadingMore, isEmpty, children }, ref) => {
  const [elementRef, { height }] = useElementSize<HTMLDivElement>();

  return (
    <div ref={elementRef} className="max-w-full relative grow">
      <div
        onScroll={handleScroll}
        ref={ref}
        style={{
          overflow: "auto",
          position: "relative",
          height: `${height}px`,
        }}
      >
        {children}
      </div>

      {isLoadingMore && (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
          <Badge variant="outline" color="gray" className="bg-muted">
            Loading More...
          </Badge>
        </div>
      )}

      {isEmpty && (
        <div className="absolute top-[160px] left-1/2 transform -translate-x-1/2">
          <Flex direction={"column"} align={"center"} gap={"2"}>
            <Text size={"3"} color={"gray"} weight={"medium"} highContrast>
              No results Found
            </Text>
            <Text size={"2"} color={"gray"}>
              Try adjusting the explore filters or refine your search
            </Text>
          </Flex>
        </div>
      )}
    </div>
  );
});

TableScrollArea.displayName = "TableScrollArea";

export { TableScrollArea };
